import classNames from 'classnames'

import { Image as BaseImage } from '@lounge-fe/ui-kit/src/components/Image'

import { MediaImageProps, MediaItemComponent } from './types'

const Image: MediaItemComponent<MediaImageProps> = ({
  className,
  zoomSrc,
  lightboxImageData,
  index = 0,
  ...props
}) => (
  <BaseImage
    className={classNames('object-center object-cover', className)}
    onLoadCapture={
      index === 0
        ? () => document.getElementById('product-page-placeholder')?.remove()
        : undefined
    }
    data-index={index}
    {...props}
  />
)

Image.mediaType = 'image'

export default Image
